module.exports = __webpack_public_path__ + "img/trofeu_o.1a911ebd.png";